module.exports = __webpack_public_path__ + "static/media/w_w_hb_35.af070134.png";